import { render, staticRenderFns } from "./temperaPro.vue?vue&type=template&id=bd3abf90&scoped=true&"
import script from "./temperaPro.vue?vue&type=script&lang=js&"
export * from "./temperaPro.vue?vue&type=script&lang=js&"
import style0 from "./temperaPro.vue?vue&type=style&index=0&lang=css&"
import style1 from "./temperaPro.vue?vue&type=style&index=1&id=bd3abf90&scoped=true&lang=css&"
import style2 from "./temperaPro.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd3abf90",
  null
  
)

export default component.exports